module.exports = __webpack_public_path__ + "img/soso_logo.a52b8f1a.png";